import type { AppCapabilities } from '@link/share/stores/appCapabilities';

/**
 * Triplabo's stance on each app-specific behaviour, for the SSR app.
 *
 * The same values as the SPA's Site store (`src/stores/modules/site.ts`), as a
 * plain object: that store fetches the site schema and touches browser
 * storage, so it cannot be imported where the server renders. Keep the two in
 * step until the SPA is gone.
 */
export const CAPABILITIES: AppCapabilities = {
  columnPlanAutoSwitch: true,
  profilePostCodeEnabled: true,
  capacityNotice: true,
  lastMonthSoldOut: true,
  voucherPdf: true,
  requireFormName: true
};
